/** TASE / Meitav statements often quote שער in agorot (1/100 shekel). */
export const AGOROT_PER_SHEKEL = 100;

const AGOROT_RATIO_MIN = 50;
const AGOROT_RATIO_MAX = 200;

/** True when `larger / smaller` looks like agorot vs shekels (~100×). */
export function isAgorotToShekelRatio(ratio: number): boolean {
  return Number.isFinite(ratio) && ratio > AGOROT_RATIO_MIN && ratio < AGOROT_RATIO_MAX;
}

/**
 * After GPT extraction, force per-share prices into shekels.
 * Trust שווי החזקה (marketValue) when price × qty is ~100× too high.
 */
export function normalizeImportedStockUnits(input: {
  amount: number;
  stockPrice: number;
  purchasePrice: number;
  marketValue: number;
}): { stockPrice: number; purchasePrice: number; marketValue: number } {
  const amount = Number(input.amount) || 0;
  let stockPrice = Number(input.stockPrice) || 0;
  let purchasePrice = Number(input.purchasePrice) || 0;
  let marketValue = Number(input.marketValue) || 0;

  if (amount <= 0) {
    return { stockPrice, purchasePrice, marketValue };
  }

  if (marketValue > 0 && stockPrice > 0) {
    const implied = stockPrice * amount;
    if (isAgorotToShekelRatio(implied / marketValue)) {
      const derived = marketValue / amount;
      stockPrice = derived > 0 ? derived : stockPrice / AGOROT_PER_SHEKEL;
    }
  } else if (stockPrice > 0 && purchasePrice > 0) {
    if (isAgorotToShekelRatio(stockPrice / purchasePrice)) {
      stockPrice /= AGOROT_PER_SHEKEL;
    }
  }

  if (purchasePrice > 0 && stockPrice > 0) {
    if (isAgorotToShekelRatio(purchasePrice / stockPrice)) {
      purchasePrice /= AGOROT_PER_SHEKEL;
    }
  }

  if (marketValue <= 0 && stockPrice > 0) {
    marketValue = amount * stockPrice;
  }

  return { stockPrice, purchasePrice, marketValue };
}
